'use strict';

function fixedHeader() {
	var lastKnownScrollPos = 0;
	var ticking = false;

	function stickyHeader(scrollPos) {
		var header = document.querySelectorAll('[role="banner"]');
		var headerArray = Array.prototype.slice.call(header);
		headerArray.forEach(function (headerNode) {

			// We want the nav to be sticky always on the Members Registration Page!
			var isMembersRegisterPage = document.querySelector('.path-member .register-account');
			if (isMembersRegisterPage) {
				headerNode.classList.add('sticky');
				return;
			}

			if (scrollPos === 0) {
				headerNode.classList.remove('sticky');
				//headerNode.setAttribute('style', 'top: 40px !important;');
			} else {
				headerNode.classList.add('sticky');
				//headerNode.setAttribute('style', 'top: 0 !important;');
			}
		});

		// Notification banner block
		var notificationBar = [].slice.call(document.querySelectorAll(".c-notification-block"));

		notificationBar.forEach(function (notifyNode) {
			if (scrollPos === 0) {
				notifyNode.classList.add('notification-bar-show');
			} else {
				notifyNode.classList.remove('notification-bar-show');
			}
		});
	}

	window.addEventListener('scroll', function (e) {
		lastKnownScrollPos = window.scrollY;

		if (!ticking) {
			window.requestAnimationFrame(function () {
				stickyHeader(lastKnownScrollPos);
				ticking = false;
			});

			ticking = true;
		}
	});
}
fixedHeader();